import setProfile from './setProfile.reducer';
import setDashboard from './setDashboard.reducer';
import setLeadsContent from './setLeadsContent.reducer';
import setCurrentPage from './setCurrentPage.reducer';
import setUnreadCount from './setUnreadCount.reducer';
import setBack from './setBack.reducer';

const mainReducer = (state, action) => {
  const {
    currentPage,
    profile,
    dashboard,
    leadsContent,
    unreadCount,
    back,
  } = state;
  return {
    ...state,
    currentPage: setCurrentPage(currentPage, action),
    profile: setProfile(profile, action),
    dashboard: setDashboard(dashboard, action),
    leadsContent: setLeadsContent(leadsContent, action),
    unreadCount: setUnreadCount(unreadCount, action),
    back: setBack(back, action),
  };
};

export default mainReducer;
